import {FC} from 'react';

import {classNames} from '../../../../../util/css';

import * as styles from './wl-logo-short.scss';

type PropsType = {
    className?: string;
};

export function getShortLogo(src: string): FC<PropsType> {
    return function LogoShort(props: PropsType): JSX.Element {
        const {className} = props;

        const fullClassName = classNames(styles.LogoShort, className);

        return <img alt="" className={fullClassName} src={src} />;
    };
}
